import React from "react";

import {provideFASTDesignSystem} from "@microsoft/fast-components";
import {provideReactWrapper, ReactWrapperProps} from "@microsoft/fast-react-wrapper";

export const {wrap} = provideReactWrapper(React, provideFASTDesignSystem());

export type BaseWrappedProps<TElement extends HTMLElement, Events extends string = never> =
    Omit<ReactWrapperProps<TElement, Record<Events, any>>, "children">;
